
import { NAME } from './constants';
import { router } from './router';

export const CompletedRequest = {
	name: NAME,
	router,
};
